export default class Youtube {
    /**
     * constructor a des variables et verifie que les video sont biens chargé dans la page
     * @param {this} element - contient un element html
     * @param {this} youtube - contient les elements pour la video
     * @param {this} youtubeId - id de la video youtube
     * @param {this} poster - contient le poster qui est au dessus de la video
     * @param {this} autoplay - permet de jouer la video instantanement lors du click sur le play
     * @param {this} playerReady - verifie si la video est ready ou non
     * 
     * 
     */
  constructor(element) {
    this.element = element;
    this.youtube = this.element.querySelector('.js-youtube');
    this.youtubeId = this.element.dataset.youtubeId;
    this.poster = this.element.querySelector('.js-poster');
    this.autoplay = this.poster ? 1 : 0;
    this.playerReady = false;

    Youtube.instances.push(this);

    if (this.youtubeId) {
      Youtube.loadScript();
    } else {
    }
  }

    /**
     * loadScript verifie que les videos soit prete dans la page avant de faire apparateitre le play
     * @param {const} script - contient le script youtube de la page
     */
  static loadScript() {
    if (!Youtube.scriptIsLoading) {
      Youtube.scriptIsLoading = true;
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(script);
    }
  }

    /**
     * initAll ajoute la classe d etat lorsque les videos sont prete
     * @param {const} instance - contient une video par instance
     */
  static initAll() {
    document.documentElement.classList.add('is-youtube-ready');
    for (let i = 0; i < Youtube.instances.length; i++) {
      const instance = Youtube.instances[i];
      instance.init();
    }
  }


    /**
     * init ajoute le click pour partir une video
     */
  init() {
    this.setOptions();
    this.initPlayer = this.initPlayer.bind(this);

    if (this.poster) {
      this.element.addEventListener('click', this.initPlayer.bind(this));
    } else {
      this.initPlayer();
    }
  }


  setOptions() {
    if ('controls' in this.element.dataset) {
      this.player.playerVars.controls = 0;
    }
  }
    /**
     * initPlayer fait jouer une video et donne des parametres/options que la video doit prendre comme partir la video des que l on click sur le bouton play et retire le poster. Il verifie que la video soit toujours dans la fenetre egalement sinon la video sera arreter
     */
  initPlayer(event) {
    if (event) {
      this.element.removeEventListener('click', this.initPlayer);
    }
    console.log(this.youtubeId);

    this.player = new YT.Player(this.youtube, {
      height: '100%',
      with: '100%',
      videoId: this.youtubeId,
      playerVars: {
        autoplay: this.autoplay,
        rel: 0,
        controls: 1,
      },
      events: {
        onReady: () => {
          this.playerReady = true;
          const observer = new IntersectionObserver(this.watch.bind(this), {
            rootMargin: ' 0px 0px 0px 0px',
          });
          observer.observe(this.element);
        },

          /**
           * onStateChange permet de visionner une seule video a la fois
           */
        onStateChange: (event) => {
          if (event.data == YT.PlayerState.PLAYING) {
            Youtube.pauseAll(this);
          } else if (event.data == YT.PlayerState.ENDED) {
            this.player.seekTo(0);
            this.player.pauseVideo();
          }
        },
      },
    });
  }

    /**
     * pauseAll permet de jouer une seule video a la fois donc il verifie si l instance est la meme que celle choisi et si non elle met sur play la nouvelle et met en pause la vielle
     */
  static pauseAll(currentInstance) {
    for (let i = 0; i < Youtube.instances.length; i++) {
      const instance = Youtube.instances[i];
      if (instance.playerReady && instance !== currentInstance) {
        instance.player.pauseVideo();
      }
    }
  }

    /**
     * watch permet de verifier si la video active est encore dans la fenetre
     */
  watch(entries) {
    if ((this.playerReady = true && !entries[0].isIntersecting)) {
      this.player.pauseVideo();
    }
  }
}

  /**
   * c est ligne stock les instances de video dans un tableau et donne le coup d envoie vers le initAll 
   */
Youtube.instances = [];
window.onYouTubeIframeAPIReady = Youtube.initAll;
